import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {View, Text, ActivityIndicator} from 'react-native';
import {
    WorkoutContainerHeaderTwo,
    WorkoutContainerHeaderThree,
    WorkoutContainerText,
    WorkoutTextSubHeader,
    WorkoutTextHeader
} from '../../../styles/common-styles.js';
import styled from 'styled-components/native';
import StreakCalendar from './StreakCalendar.js';
import {fetchLatestStreakDates} from '../../../reducers/cbcStreakSlice';


function WorkoutStreak({user_id}) {

    //////console.log("WorkoutStreak render");

    const {streak_dates, current_active_streak} = useSelector((state) => state.streakDates);

    const dispatch = useDispatch();
    const [loadingFinished, setLoadingFinished] = useState(false);
    const [streakDatesObj, setStreakDatesObj] = useState();

    useEffect(() => {
        if (user_id > 0) {
            dispatch(fetchLatestStreakDates(user_id)).then((ret) => {
                ////console.log(ret.payload.streak_calendar);
                addIndexToStreakDates(ret.payload.streak_calendar).then((ret) => {
                    ////console.log(ret);
                    setStreakDatesObj(ret);
                    setLoadingFinished(true);
                });
                ////console.log(streakDatesObj);
            })
        }
    }, [user_id]);


    async function addIndexToStreakDates(calendar) {
        const newStreakDates = calendar.map((date, index) => {
            return {
                ...date,
                index: index
            };
        });

        return newStreakDates
    }

    return (
        <WorkoutStreakParent>
            <WorkoutContainerHeaderThree style={{marginBottom: 10}}>
                Train 3 times a week to earn a streak
            </WorkoutContainerHeaderThree>
            <StreakCalendar date_obj={streakDatesObj}/>
            <StreakCountContainer>
                <WorkoutTextSubHeader style={{fontSize: 15}}>
                    STREAK TOTAL
                </WorkoutTextSubHeader>
                <FlameContainer>
                    <WorkoutTextSubHeader style={{fontSize: 30}}>
                        {current_active_streak}
                    </WorkoutTextSubHeader>
                    <Flame
                        source={{
                            uri: `https://dev.cerebrocoreusa.com/wp-content/uploads/2023/06/CerebroCore_Icons_streak-fire.png`,
                        }}
                    />
                </FlameContainer>
            </StreakCountContainer>
        </WorkoutStreakParent>
    );

}

export const WorkoutStreakParent = styled.View`
  background: transparent;
  width: 100%;
  max-width: 350px;
  height: 350px;
  padding: 25px 0px 10px 0px;
  border: 2px solid #badbff;
  border-radius: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
`;

export const ActivityIndicatorParent = styled.View`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StreakCountContainer = styled.View`
  width: 80%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`

export const FlameContainer = styled.View`
  width: auto;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
`

export const Flame = styled.Image`
  margin-bottom: 15px;
  resizeMode: contain;
  width: 35px;
  height: 60px;
  margin-left: 7.5px;
`

export default WorkoutStreak;
